import Campus01 from "../../../assets/images/Sports/Imga (1).jpeg";
import Campus02 from "../../../assets/images/Sports/Imga (2).jpeg";
import Campus03 from "../../../assets/images/Sports/Imga (3).jpeg";
import Campus04 from "../../../assets/images/Sports/Imga (4).jpeg";
import Campus05 from "../../../assets/images/Sports/Imga (5).jpeg";
import Campus06 from "../../../assets/images/Sports/Imga (6).jpeg";
import Campus07 from "../../../assets/images/Sports/Imga (7).jpeg";
import Campus08 from "../../../assets/images/Sports/Imga (8).jpeg";
import Campus09 from "../../../assets/images/Sports/Imga (9).jpeg";
import Campus010 from "../../../assets/images/Sports/Imga (10).jpeg";
import Campus011 from "../../../assets/images/Sports/Imga (11).jpeg";

import Campus1 from "../../../assets/images/Sports/Img (1).jpg";
import Campus2 from "../../../assets/images/Sports/Img (2).jpg";
import Campus3 from "../../../assets/images/Sports/Img (3).jpg";
import Campus4 from "../../../assets/images/Sports/Img (4).jpg";
import Campus5 from "../../../assets/images/Sports/Img (5).jpg";
import Campus6 from "../../../assets/images/Sports/Img (6).jpg";
import Campus7 from "../../../assets/images/Sports/Img (7).jpg";
import Campus8 from "../../../assets/images/Sports/Img (8).jpg";
import Campus9 from "../../../assets/images/Sports/Img (9).jpg";
import Campus10 from "../../../assets/images/Sports/Img (10).jpg";
import Campus12 from "../../../assets/images/Sports/Img (12).jpg";
import Campus11 from "../../../assets/images/Sports/Img (13).jpg";
import Campus13 from "../../../assets/images/Sports/Img (14).jpg";
import Campus14 from "../../../assets/images/Sports/Img (15).jpg";
import Campus15 from "../../../assets/images/Sports/Img (16).jpg";
import Campus16 from "../../../assets/images/Sports/Img (17).jpg";
import Campus17 from "../../../assets/images/Sports/Img (18).jpg";
import Campus18 from "../../../assets/images/Sports/Img (19).jpg";
import Campus19 from "../../../assets/images/Sports/Img (20).jpg";
import Campus20 from "../../../assets/images/Sports/Img (11).jpg";
import Campus21 from "../../../assets/images/Sports/Img (21).jpg";
import Campus22 from "../../../assets/images/Sports/Img (22).jpg";
import Campus23 from "../../../assets/images/Sports/Img (23).jpg";
import Campus24 from "../../../assets/images/Sports/Img (24).jpg";
import Campus25 from "../../../assets/images/Sports/Img (25).jpg";
import Campus26 from "../../../assets/images/Sports/Img (26).jpg";
import Campus27 from "../../../assets/images/Sports/Img (27).jpg";
import Campus28 from "../../../assets/images/Sports/Img (28).jpg";
import Campus29 from "../../../assets/images/Sports/Img (29).jpg";
import Campus30 from "../../../assets/images/Sports/Img (30).jpg";
import Campus31 from "../../../assets/images/Sports/Img (31).jpg";
import Campus32 from "../../../assets/images/Sports/Img (32).jpg";

const campusImages = [
  Campus01,
  Campus02,
  Campus03,
  Campus04,
  Campus05,
  Campus06,
  Campus07,
  Campus08,
  Campus09,
  Campus010,
  Campus011,
  Campus1,
  Campus2,
  Campus3,
  Campus4,
  Campus5,
  Campus6,
  Campus7,
  Campus8,
  Campus9,
  Campus10,
  Campus11,
  Campus12,
  Campus13,
  Campus14,
  Campus15,
  Campus16,
  Campus17,
  Campus18,
  Campus19,
  Campus20,
  Campus21,
  Campus22,
  Campus23,
  Campus24,
  Campus25,
  Campus26,
  Campus27,
  Campus28,
  Campus29,
  Campus30,
  Campus31,
  Campus32,
];

export default campusImages;
